module.exports = __webpack_public_path__ + "static/media/guanyinshan_plant.b3123426.webp";